import React from 'react';
import styles from './BookingForm.module.css';
import { FaRegCalendarAlt, FaMapMarkerAlt, FaUser, FaEnvelope, FaPhone } from 'react-icons/fa';
import toast from 'react-hot-toast'; // ✅ استدعاء مكتبة التوست

const BookingForm = ({ onClose, serviceTitle, servicePrice }) => {
  const handleSubmit = (e) => {
    e.preventDefault();

    // ✅ رسالة نجاح بعد ملء النموذج
    toast.success(`${serviceTitle} service booked successfully!`, {
      duration: 2000,
    });
    onClose(); // يقفل المودال بعد الحجز
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <button className={styles.closeButton} onClick={onClose}>×</button>
        <h2>Book Service</h2>
        <h3>{serviceTitle}</h3>
        <form onSubmit={handleSubmit}>
          <div className={styles.inputGroup}>
            <FaRegCalendarAlt className={styles.icon} />
            <input type="date" placeholder="Select Date" required />
          </div>

          <div className={styles.inputGroup}>
            <FaMapMarkerAlt className={styles.icon} />
            <input type="text" placeholder="Location" required />
          </div>

          <div className={styles.inputGroup}>
            <FaUser className={styles.icon} />
            <input type="text" placeholder="Full Name" required />
          </div>

          <div className={styles.inputGroup}>
            <FaEnvelope className={styles.icon} />
            <input type="email" placeholder="Email Address" required />
          </div>

          <div className={styles.inputGroup}>
            <FaPhone className={styles.icon} />
            <input type="tel" placeholder="Phone Number" required />
          </div>

          <div className={styles.price}>
            <span>Price:</span>
            <span>₹{servicePrice}</span>
          </div>

          <button type="submit" className={styles.submitButton}>
            Confirm Booking
          </button>
        </form>
      </div>
    </div>
  );
};

export default BookingForm;
